export const KEYS = {
  A: 'a',
  O: 'o',
  ESCAPE: 'escape',
  ENTER: 'enter',
  SPACE: ' ',
  ARROW_UP: 'arrowup',
  ARROW_DOWN: 'arrowdown',
  ARROW_LEFT: 'arrowleft',
  ARROW_RIGHT: 'arrowright',
  TAB: 'tab',
} as const;
